var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 3C16 2.66874 15.7316 2.3996 15.4004 2.39941C15.069 2.39941 14.7998 2.66863 14.7998 3V5.39746L8.81836 0.891602L5.71582 3.35645L0.9375 0.103516C0.663575 -0.0827036 0.289895 -0.011168 0.103516 0.262695C-0.0824584 0.536582 -0.0110425 0.909378 0.262695 1.0957L5.77051 4.84473L6.11523 4.56934L8.83789 2.4082L14.1367 6.39941H11.7998C11.4685 6.39954 11.2002 6.66871 11.2002 7C11.2004 7.33111 11.4687 7.59948 11.7998 7.59961H16V3Z",
    fill: "#D35E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRed);
export default __webpack_public_path__ + "static/media/ArrowRed.a131f6f7f9edf1bcfbd063531babb556.svg";
export { ForwardRef as ReactComponent };